import isAuthenticatedGuard from "@/pages/Auth/guards/is-authenticated.guard";

// Chrome/Android avisan que la app es instalable una sola vez, al cargar: se guarda el aviso
// para el botón «Instalar app» de /chat, que puede montarse después.
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__exportaiInstallPrompt = e;
  });
}

export const TELEGRAM_AI_MODULE_NAME = "telegram_ai_module";

/** Acceso al chat del Agente IA en el menú lateral. */
export const agentChatMenuItem = {
  icon: "comments",
  path: "/chat",
};

/** Rutas de pantalla eliminadas: configuración Telegram en /settings (sección Parámetros de Telegram) */
export const telegramAiModuleRoutes = [];

/**
 * Chat del Agente IA a pantalla completa, sin layout del dashboard.
 * El back exige módulo activo y acceso del usuario al módulo (/api/agent-chat/status).
 */
export const telegramAiStandaloneRoutes = [
  {
    path: "/chat",
    name: "AgentChat",
    component: () => import("./pages/AgentChat.vue"),
    beforeEnter: isAuthenticatedGuard,
    meta: { title: "Agente IA" },
  },
];

export default {
  routes: telegramAiModuleRoutes,
};
